<template>
  <div id="radio-components">
    <div class="form-group" :description="description">
      <label v-if="label !== ''" :for="name">
        {{ label }}
        <span v-if="mandatory" class="text-danger"> * </span>
        <a
          v-if="tooltipMessage"
          v-b-tooltip.hover.top="tooltipMessage"
          href="javascript:void(0)"
        >
          <font-awesome-icon
            class="mx-1"
            :icon="`fa-solid fa-exclamation-circle`"
          />
        </a>
      </label>

      <br v-if="label !== ''" />

      <fieldset :disabled="isDisable">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="form-check my-1"
          :class="{ 'form-check-inline': isInline }"
        >
          <input
            v-model="localValue"
            :id="option?.text"
            :value="option?.value"
            type="radio"
            class="form-check-input mt-2"
            :name="name"
            @change="$emit('inputEvent', )"
          />
          <label class="form-check-label" :for="option?.text">
            {{ option?.text }}
          </label>
        </div>
      </fieldset>
    </div>
    <!-- display error messages -->
    <error-message-new :index="index" :errors="errors" :fieldName="name" />
  </div>
</template>

<script>
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    tooltipMessage: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    radioId: {
      type: [Number, String],
    },
    type: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    radioValue: {
      type: [String, Number, Boolean],
    },
    value: {
      type: [String, Number, Boolean],
    },
    description: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    parent: {
      type: String,
      default: null,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    isInline: {
      type: Boolean,
      default: true,
    },
    tooltipMessage: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    localValue: null,
  }),
  watch: {
    modelValue: {
      handler(val) {
        this.localValue = val;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleFieldState,
  },
};
</script>
